const isEveryio = () => window.partner === "everyio" || window.location.pathname.slice(0, 8) === "/everyio";

export default isEveryio;
